import React from 'react';

export type Crumb = { label: string; onClick?: () => void };

/**
 * Jedinstveni breadcrumb za module s hijerarhijom (npr. 40 → 40.2).
 * Zadnja stavka je uvijek trenutna stranica (nije klikabilna).
 */
export function Breadcrumb({ items }: { items: Crumb[] }) {
    return (
        <nav className="bi-breadcrumb" aria-label="Breadcrumb">
            {items.map((crumb, i) => {
                const isLast = i === items.length - 1;
                return (
                    <React.Fragment key={`${crumb.label}-${i}`}>
                        {i > 0 ? <span className="bi-breadcrumb-sep">›</span> : null}
                        {crumb.onClick && !isLast ? (
                            <button type="button" className="bi-breadcrumb-link" onClick={crumb.onClick}>
                                {crumb.label}
                            </button>
                        ) : (
                            <span className={isLast ? 'bi-breadcrumb-current' : 'bi-breadcrumb-text'} aria-current={isLast ? 'page' : undefined}>
                                {crumb.label}
                            </span>
                        )}
                    </React.Fragment>
                );
            })}
        </nav>
    );
}
